<mp-filter-group [filterName]="filterName()" [icon]="icon()" [searchable]="false" [(isExpanded)]="isExpanded">
  @if (showSelectionInfo() && selectedOption(); as selectedOption) {
    <mp-filter-selection-info
      filter-group-selection-info
      class="truncate"
      [label]="selectedOption.label"
      [icon]="selectedOption.icon"
    />
  }

  <mp-single-selection-filter
    [options]="options()"
    [selectedValue]="selectedValue()"
    (selectedValueChange)="onSelectionChanged($event)"
    (optionSelect)="onOptionSelected($event)"
  />
</mp-filter-group>
